import React from 'react'
import HeaderSection from '../../../../components/common/Header/HeaderSection'
import PaymentTable from './PaymentTable'
import{Box} from '@chakra-ui/react';

const Liability = () => {
    return (
        <div>
            <HeaderSection
                title="View Payment"
                breadcrumb={["Dashboard", "Voucher", "Payment"]}
            />
                        <Box p={6}>

            <PaymentTable />
            </Box>
        </div>
    )
}

export default Liability